// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"styles_gridItem__1fbk_"};